import { MasterDataTable } from "@/components/MasterDataTable";
import { useEvidenceTypes, useEvidenceTypeAdmin } from "@/hooks/useMasterData";

const EvidenceTypes = () => {
  const { data: evidenceTypes = [], isLoading } = useEvidenceTypes();
  const admin = useEvidenceTypeAdmin();

  return (
    <MasterDataTable
      items={evidenceTypes.map((i) => ({ id: i.id, label: i.name, is_active: i.is_active }))}
      valueLabel="Name"
      isLoading={isLoading}
      onCreate={(name) => admin.create.mutateAsync(name)}
      onUpdate={(id, data) => admin.update.mutateAsync({ id, data })}
      onDelete={(id) => admin.remove.mutateAsync(id)}
    />
  );
};

export default EvidenceTypes;
